module.exports = __webpack_public_path__ + "static/e9dd33a405a986f90f985fd9815a69a9c7a77a1584ace6b8f248f464e23ecc8a-58adb4ab61e66181d547491ab3493f62.jpeg";